import { type WorkflowStageData, type WorkflowStageId } from '../../model'

/** Callers that cannot load the workflow must fail closed (treat as flagged), not substitute an empty stage list. */
export function getRecordingFlagStageIds(stages: readonly WorkflowStageData[]): Set<WorkflowStageId> {
  return new Set(stages.filter((stage) => stage.aiConfig?.flagRecordings === true).map((stage) => stage.stageId))
}
